export interface PaymentDiscount {
  discount?: boolean;
  discountPeriod?: number;
  firstDiscountPayment?: number;
  numFreePayments?: number;
  subsequentDiscountPayment?: number;
  totalOfDiscount?: number;
}
